export default __webpack_public_path__ + "static/media/A6_printing_rules_inches.802d3e1b.pdf";